import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AccessUserEditLink from './AccessUserEditLink'

class AccessUserEditLinkContainer extends React.Component {
  static propTypes = {
    /* passed props */
    accessId: PropTypes.number.isRequired,
    /* mapped state */
    doorAccesses: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      doorAccesses: state.doorAccesses,
    }
  }

  render() {
    const { accessId, doorAccesses } = this.props
    const doorAccess = doorAccesses[accessId] || {}
    const linkText = doorAccess.name || accessId
    const isUserEnabled = doorAccess.enabled === true

    return (
      <AccessUserEditLink
        accessId={accessId}
        isUserEnabled={isUserEnabled}
        linkText={linkText}
      />
    )
  }
}

export default connect(
  AccessUserEditLinkContainer.mapStateToProps,
)(AccessUserEditLinkContainer)
